export default __webpack_public_path__ + "static/lutein-vijdame-header-thumb-4fa29cb25f42546afbc7c8d33ea3576d.jpg";